import {
  ACTION_ICONS_NAMESPACE,
  CustomButton,
  ExportButtonDropdown,
  filterOperatorValues,
  SvgVerticalSplitter,
} from '@ui-kit'
// import { CustomTable } from '@ui-kit'
import { CALL_INTERACTION_STRINGS } from '../utils/strings'
import { useState, useEffect, useRef } from 'react'
// import { TableColumnType } from '@ui-kit'
import {
  getCategoryDropdownOptions,
  getEntityDataByEntityIdLayoutIdApiForFilter,
  getInteraction,
  getLayoutByName,
  hideLoader,
  // getPermissionAssignmentList,
  LayoutResponseType,
  setClientDropdown,
  showLoader,
  SORT_KEYS,
  updateIntakeCommunicationMap,
} from '@app-store'
// import { convertToCamelCase } from '../utils/helperFunctions'
import { callRoute } from '../routes/route.constant'
import { useLocation, useNavigate } from 'react-router-dom'
import { ListingTable } from '../components/listing-table/ListingTable'
import { RootState, useAppDispatch, useAppSelector } from '../utils/agent.store'
import { ListingTableProps } from '../types/listingTable.types'
import {
  componentNames,
  ENTITY_TABLE_EXPORT_EVENT,
  NAMESPACES,
} from '../utils/constants'
import { DatePickerRef } from 'react-multi-date-picker'
import { isReadOnlyUser } from '../utils/permission'
import { RECORD_STATUS, ShortcutKeys } from '../constants/form.constants'

// interface CallInteraction {
//   id: string
//   createdAt: string
//   program: string
//   product: string
//   agent: string
//   requesterType: string
//   requesterID: string
//   caseType: string
// }

// const data = [
//   {
//     id: 'I-1001',
//     createdAt: '03/22/2025 04:30 PM',
//     program: 'ADMA',
//     product: 'ASCENIV',
//     agent: 'Nicholas Pearson',
//     requesterType: 'Provider',
//     requesterID: 'PR-789',
//     caseType: 'General Inquiry',
//   },
//   {
//     id: 'I-1002',
//     createdAt: '03/22/2025 03:45 PM',
//     program: 'ADMA',
//     product: 'BIVIGAM',
//     agent: 'Ethan Davis',
//     requesterType: 'Patient',
//     requesterID: 'P-123',
//     caseType: 'General Inquiry',
//   },
//   {
//     id: 'I-1003',
//     createdAt: '03/22/2025 02:15 PM',
//     program: 'ADMA',
//     product: 'ASCENIV',
//     agent: 'Olivia Martinez',
//     requesterType: 'Provider',
//     requesterID: 'PR-456',
//     caseType: 'General Inquiry',
//   },
//   {
//     id: 'I-1004',
//     createdAt: '03/22/2025 01:00 PM',
//     program: 'ADMA',
//     product: 'BIVIGAM',
//     agent: 'Sophia Johnson',
//     requesterType: 'Patient',
//     requesterID: 'P-789',
//     caseType: 'General Inquiry',
//   },
// ]

// const columns: TableColumnType<CallInteraction>[] = [
//   { header: 'Interaction ID', accessor: 'id', isSortable: true },
//   { header: 'Created At', accessor: 'createdAt', isSortable: true },
//   { header: 'Program', accessor: 'program', isSortable: true },
//   { header: 'Product', accessor: 'product', isSortable: true },
//   { header: 'Agent Name', accessor: 'agent', isSortable: true },
//   { header: 'Requester Type', accessor: 'requesterType', isSortable: true },
//   { header: 'Requester ID', accessor: 'requesterID', isSortable: true },
//   { header: 'Case Type', accessor: 'caseType' },
// ]
export default function InteractionListing({
  caseId,
  isCaseView = false,
}: {
  caseId?: string
  isCaseView?: boolean
}) {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [listingLayout, setListingLayout] = useState<LayoutResponseType>()
  const [fetchKey, setFetchKey] = useState<number>(0)
  const selectedTenantId = useAppSelector(
    (state: RootState) => state.authUser.selectedClientTenant?.id
  )

  const userId = useAppSelector((state) => state?.authUser?.user?.id)
  const intakeCommunicationMap = useAppSelector(
    (state) => state?.workflowData?.intakeCommunicationMap
  )
  const [loadingLayout, setLoadingLayout] = useState<boolean>(false)
  const location = useLocation()

  // const getInitialDateValues = () => {
  //   const date = [new DateObject().subtract(7, 'days'), new DateObject()]
  //   return [
  //     `${date[0]?.month?.number}/${date[0]?.day}/${date[0]?.year}`,
  //     `${date[1]?.month?.number}/${date[1]?.day}/${date[1]?.year}`,
  //   ]
  // }
  // const [values, setValues] = useState<string[]>(getInitialDateValues())
  // const todayString = moment().format('YYYY-MM-DD') + 'T23:59:59.999Z'
  // const sevenDaysAgoString =
  // moment().subtract(7, 'days').format('YYYY-MM-DD') + 'T00:00:00.000Z'
  // const [calenderDates, setCalenderDates] = useState<string[]>([
  //   sevenDaysAgoString,
  //   todayString,
  // ])
  const pickerRef = useRef<DatePickerRef | undefined>(undefined)
  const [calendarOpen, setCalendarOpen] = useState<boolean>(false)
  const previouslyFocusedElementRef = useRef<HTMLElement | null>(null)

  // const [refetchKey, setRefetchKey] = useState<number>(0)
  // const [listData, setListData] = useState<CallInteraction[]>(data)

  // const [sortDirection, setSortDirection] = useState<{
  //   keyName: string
  //   direction: 'asc' | 'desc'
  // }>({
  //   keyName: 'firstName',
  //   direction: 'asc',
  // })

  // const [currentPage, setCurrentPage] = useState<number>(1)
  // const [rowPerPage, setRowPerPage] = useState<number>(10)
  // const [totalPages, setTotalPages] = useState<number>(1)

  // const fetchData = async (
  //   resetPage?: boolean,
  //   sortDir?: {
  //     keyName: string
  //     direction: 'asc' | 'desc'
  //   }
  // ) => {
  //   if (resetPage) setCurrentPage(1)
  //   try {
  //     const response = await getPermissionAssignmentList({
  //       page: resetPage ? 1 : currentPage,
  //       size: rowPerPage,
  //       filter: {
  //         fields: null,
  //       },
  //       sort: `${sortDir ? sortDir?.keyName : sortDirection?.keyName},${
  //         sortDir ? sortDir?.direction : sortDirection?.direction
  //       }`,
  //     })
  //     console.log(response)
  //     setTotalPages(1)
  //     setListData(data)
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }

  // const onSortClick = (key: string, isAsc: boolean) => {
  //   if (key) {
  //     const newKeyName = convertToCamelCase(key)
  //     setSortDirection({
  //       keyName: newKeyName,
  //       direction: isAsc ? 'asc' : 'desc',
  //     })
  //     fetchData(false, {
  //       keyName: newKeyName,
  //       direction: isAsc ? 'asc' : 'desc',
  //     })
  //   }
  // }
  // const handlePageChange = async (page: number, newRowsPerPage: number) => {
  //   try {
  //     if (page < 1 || newRowsPerPage < 1) {
  //       console.error('Invalid pagination values:', { page, newRowsPerPage })
  //       return
  //     }
  //     const selectedPage = rowPerPage !== newRowsPerPage ? 1 : page
  //     const response = await getPermissionAssignmentList({
  //       page: selectedPage,
  //       size: newRowsPerPage,
  //       filter: {
  //         fields: null,
  //       },
  //       sort: `${sortDirection?.keyName},${sortDirection?.direction}`,
  //     })
  //     console.log(response)
  //     setCurrentPage(page)
  //     setRowPerPage(newRowsPerPage)
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }
  // const handleDateChange = (date: DateObject[]) => {
  //   if (!date || date.length !== 2) return

  //   const formatISODate = (d: DateObject, endOfDay = false) => {
  //     const year = d?.year
  //     const month = String(d?.month?.number).padStart(2, '0')
  //     const day = String(d?.day).padStart(2, '0')
  //     const time = endOfDay ? 'T23:59:59.999Z' : 'T00:00:00.000Z'
  //     return `${year}-${month}-${day}${time}`
  //   }

  //   const formatDisplayDate = (d: DateObject) =>
  //     `${d?.month?.number}/${d?.day}/${d?.year}`

  //   const startDisplay = formatDisplayDate(date[0])
  //   const endDisplay = formatDisplayDate(date[1])

  //   const startISO = formatISODate(date[0])
  //   const endISO = formatISODate(date[1], true)

  //   setValues([startDisplay, endDisplay])
  //   setCalenderDates([startISO, endISO])
  //   setRefetchKey((prev) => prev + 1)
  // }

  const fetchTableDataCallback: ListingTableProps['dataFetchCallback'] = async (
    payload
  ) => {
    dispatch(showLoader())
    const filterObject = {
      values: Object.keys(intakeCommunicationMap ?? {}),
      field_name: 'category_communication_type_id',
      operation: filterOperatorValues.EQUALS,
    }
    payload.filters[0].criteria.push(filterObject)
    payload.filters[0].criteria.push({
      field_name: 'communication_status',
      operation: filterOperatorValues.IS_EMPTY_NULL,
      values: [''],
    })
    payload.filters[0].criteria.push({
      field_name: 'record_status',
      operation: filterOperatorValues.EQUALS,
      values: [RECORD_STATUS.ACTIVE],
    })
    payload = {
      ...payload,
      select: [...(payload.select ?? []), 'category_status'],
      related_entities: {
        ...(payload.related_entities ?? {}),
        category_status: {
          ...(payload.related_entities?.category_status ?? {}),
          select: ['value'],
          filters: [
            ...(payload.related_entities?.category_status?.filters ?? []),
            {
              criteria: [
                {
                  field_name: 'value',
                  operation: filterOperatorValues.NOT_EQUALS,
                  values: ['DISCARDED'],
                },
              ],
            },
          ],
        },
      },
    }
    // if (calenderDates) {
    //   const filterDateObject = {
    //     values: calenderDates,
    //     field_name: 'created_at',
    //     operation: 'BETWEEN',
    //   }
    //   payload.filters[0].criteria.push(filterDateObject)
    // }
    const response = await getEntityDataByEntityIdLayoutIdApiForFilter({
      payload,
      entityName: 'communication',
    })
    dispatch(hideLoader())
    return response.data
  }

  const fetchLayouts = async () => {
    try {
      setLoadingLayout(true)
      dispatch(showLoader())
      let foundSearchLayout = false
      const response = await getLayoutByName({
        entityId: '59',
        layoutName: 'Interaction Layout',
      })
      setListingLayout(response.data)
      if (response.data) {
        if (response.data) {
          response.data.layout_data.pages[0].rows[0].columns[0].elements.forEach(
            (
              ele: (typeof response.data.layout_data.pages.rows.columns.elements)[0]
            ) => {
              if (ele.keyName.includes('case')) {
                ele.elementName = componentNames.SINGLE_LOOKUP_CLICK
              }
            }
          )
          foundSearchLayout = true
        }
      }
      if (!foundSearchLayout) setListingLayout(undefined)
      setFetchKey((prev) => prev + 1)
    } catch (err) {
      console.error(err)
    } finally {
      setLoadingLayout(false)
      dispatch(hideLoader())
    }
  }

  const handleCreateInteraction = async () => {
    try {
      dispatch(showLoader())
      const response = await getInteraction(userId ?? '')
      if (response?.data?.id) {
        navigate(`/${callRoute}/create/${response.data.id}`)
      }
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const getIntakeCommunicationMapping = async () => {
    const communicationTypes = await getCategoryDropdownOptions(
      'communication_type',
      ['name', 'value', 'label']
    )
    const intakeTypes = await getCategoryDropdownOptions('Intake Channel', [
      'name',
      'value',
      'label',
    ])
    const intakeCommunicationMap: Record<string, string> = {}
    communicationTypes.data.forEach(
      (comm: (typeof communicationTypes.data)[0]) => {
        const intake = intakeTypes.data.find(
          (int: (typeof intakeTypes.data)[0]) =>
            int.value.toLowerCase().startsWith(comm.label.toLowerCase())
        )
        if (intake) {
          intakeCommunicationMap[comm.id] = intake.id
        }
      }
    )
    dispatch(updateIntakeCommunicationMap(intakeCommunicationMap))
  }

  useEffect(() => {
    fetchLayouts()
    getIntakeCommunicationMapping()
  }, [selectedTenantId])

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === ShortcutKeys.Escape && calendarOpen) {
        setCalendarOpen(false)
        if (pickerRef.current) {
          pickerRef?.current?.closeCalendar()
          previouslyFocusedElementRef?.current?.focus()
        }
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [calendarOpen])

  useEffect(() => {
    dispatch(setClientDropdown({ isVisible: true, isGlobalVisible: false }))
  }, [location])

  return (
    <div className="h-full flex flex-col">
      {!isCaseView && (
        <div className="flex justify-between items-center px-3 py-2 border-b-2">
          <span className="text-base font-medium">
            {CALL_INTERACTION_STRINGS.CALL_INTERACTION}
          </span>
          <div className="flex gap-4 items-center">
            {/* <div className="flex items-center justify-center ml-auto border border-accent-300 p-2 rounded-lg gap-1">
            <div>
              <SvgCalendar />
            </div>
            <div>
              <DatePicker
                value={values}
                ref={pickerRef}
                range
                rangeHover
                onChange={handleDateChange}
                numberOfMonths={2}
                format="M/D/YYYY"
                dateSeparator=" - "
                render={(value: string, openCalendar: () => void) => (
                  <CustomRangeInput
                    value={value}
                    onFocus={() => {
                      previouslyFocusedElementRef.current =
                        document.activeElement as HTMLElement
                      openCalendar()
                    }}
                  />
                )}
                onOpen={() => setCalendarOpen(true)}
                onClose={() => setCalendarOpen(false)}
              />
            </div>
          </div> */}
            {!isReadOnlyUser() && (
              <>
                <ExportButtonDropdown
                  showCSV={true}
                  showExcel={false}
                  onExportOption={() =>
                    dispatchEvent(new Event(ENTITY_TABLE_EXPORT_EVENT))
                  }
                  // customCSS="-translate-x-3/4"
                  dataQaId="correspondence-export-btn"
                />
                <SvgVerticalSplitter height={'2rem'} />
              </>
            )}
            <CustomButton
              color="primary"
              isFilled={true}
              dataQaId="create-new-interaction-btn"
              widthClass="w-auto"
              onClick={handleCreateInteraction}
              disabled={isReadOnlyUser()}
            >
              <span className="font-primary font-light text-xs">
                {CALL_INTERACTION_STRINGS.CREATE_NEW_INTERACTION}
              </span>
            </CustomButton>
          </div>
        </div>
      )}

      {listingLayout && intakeCommunicationMap ? (
        <div className="flex flex-1 min-h-0 min-w-0 flex-col overflow-y-auto">
          <ListingTable
            entityId={59}
            entityName={'communication'}
            layout={listingLayout}
            dataFetchCallback={fetchTableDataCallback}
            isLoading={loadingLayout}
            key={fetchKey}
            // refetchKey={refetchKey}
            sortDirection={{
              keyName: 'created_at',
              direction: SORT_KEYS.Desc,
              isAsc: SORT_KEYS.Desc,
              key: 'created_at',
            }}
            extraActions={
              isReadOnlyUser()
                ? []
                : [
                    {
                      label: NAMESPACES.EDIT,
                      key: ACTION_ICONS_NAMESPACE.EDIT,
                      onClick: (row) => {
                        const editUrl = `/${callRoute}/edit/${row.id}`
                        if (isCaseView) {
                          window.open(editUrl, '_blank', 'noreferrer')
                        } else {
                          navigate(editUrl)
                        }
                      },
                    },
                  ]
            }
            allLayouts={listingLayout ? [listingLayout] : undefined}
            caseId={caseId}
            isCaseView={isCaseView}
          />
        </div>
      ) : null}
    </div>
  )
}

// const CustomRangeInput = ({
//   value,
//   onFocus,
// }: {
//   onFocus: () => void
//   value: string
// }) => {
//   return (
//     <input
//       onClick={() => onFocus()}
//       value={value}
//       style={{
//         width: '12rem',
//         border: 'none',
//         outline: 'none',
//         cursor: 'pointer',
//       }}
//       onKeyDown={(e) => {
//         if (e?.key === ShortcutKeys.Enter || e?.key === ShortcutKeys.Space) {
//           onFocus()
//           e?.preventDefault()
//         }
//       }}
//       readOnly
//     />
//   )
// }
